module.exports = __webpack_public_path__ + "img/login-icon.e3f188c2.svg";